import {
  CREATE_NICHE_CONTEXT_HASH,
  CREATE_TERRITORY_NICHE_CONTEXT,
  DELETE_TERRITORY_NICHE_CONTEXT,
  GET_TERRITORY_NICHE_CONTEXTS,
  GROUP_NICHES,
  RENAME_NICHES,
  GET_TERRITORY_MAIN_NICHES,
} from './operations'
import type { TNicheMutationsMap, TNicheQueriesMap } from './types'

export const GRAPHQL_NICHE_QUERIES: TNicheQueriesMap = {
  getTerritoryNicheContexts: GET_TERRITORY_NICHE_CONTEXTS,
  getTerritoryMainNiches: GET_TERRITORY_MAIN_NICHES,
}

export const GRAPHQL_NICHE_MUTATIONS: TNicheMutationsMap = {
  deleteTerritoryNicheContext: DELETE_TERRITORY_NICHE_CONTEXT,
  createTerritoryNicheContext: CREATE_TERRITORY_NICHE_CONTEXT,
  createNicheContextHash: CREATE_NICHE_CONTEXT_HASH,
  groupNiches: GROUP_NICHES,
  renameNiches: RENAME_NICHES,
}
